/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptCreative } from '../models/V3StackAdaptCreative';
import { V3StackAdaptUserMetadata } from '../models/V3StackAdaptUserMetadata';
import { V3StackAdaptVastMedia } from '../models/V3StackAdaptVastMedia';
import { V3StackAdaptVastTracker } from '../models/V3StackAdaptVastTracker';
import { HttpFile } from '../http/http';

/**
* Ad configuration for StackAdapt campaign
*/
export class V3StackAdaptAd {
    /**
    * Ad ID
    */
    'id'?: string;
    /**
    * Ad name
    */
    'name'?: string;
    /**
    * Click URL for the ad
    */
    'clickUrl'?: string;
    'creative'?: V3StackAdaptCreative;
    /**
    * User metadata for the ad
    */
    'userMetadata'?: Array<V3StackAdaptUserMetadata>;
    /**
    * Brand name
    */
    'brandname'?: string;
    /**
    * Tracking / VAST URLs for the ad
    */
    'trackingUrls'?: Array<V3StackAdaptVastTracker>;
    /**
    * Heading for the ad
    */
    'heading'?: string;
    /**
    * Tagline for the ad
    */
    'tagline'?: string;
    /**
    * Logo ID for the ad
    */
    'logoId'?: string;
    /**
    * Custom JavaScript tracker code for the ad.
    */
    'customJsTrackerCode'?: string;
    /**
    * Call to action text for the ad.
    */
    'cta'?: string;
    /**
    * Paid by text for the ad. Only applicable for video ads.
    */
    'paidBy'?: string;
    /**
    * VAST import key for allowing StackAdapt to import VAST tags. Only applicable for video ads.
    */
    'vastImportKey'?: string;
    'vastMedia'?: V3StackAdaptVastMedia;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "clickUrl",
            "baseName": "clickUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "creative",
            "baseName": "creative",
            "type": "V3StackAdaptCreative",
            "format": ""
        },
        {
            "name": "userMetadata",
            "baseName": "userMetadata",
            "type": "Array<V3StackAdaptUserMetadata>",
            "format": ""
        },
        {
            "name": "brandname",
            "baseName": "brandname",
            "type": "string",
            "format": ""
        },
        {
            "name": "trackingUrls",
            "baseName": "trackingUrls",
            "type": "Array<V3StackAdaptVastTracker>",
            "format": ""
        },
        {
            "name": "heading",
            "baseName": "heading",
            "type": "string",
            "format": ""
        },
        {
            "name": "tagline",
            "baseName": "tagline",
            "type": "string",
            "format": ""
        },
        {
            "name": "logoId",
            "baseName": "logoId",
            "type": "string",
            "format": ""
        },
        {
            "name": "customJsTrackerCode",
            "baseName": "customJsTrackerCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "cta",
            "baseName": "cta",
            "type": "string",
            "format": ""
        },
        {
            "name": "paidBy",
            "baseName": "paidBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "vastImportKey",
            "baseName": "vastImportKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "vastMedia",
            "baseName": "vastMedia",
            "type": "V3StackAdaptVastMedia",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptAd.attributeTypeMap;
    }

    public constructor() {
    }
}

